import { useRouter } from 'next/router';

import type { RouteType } from '@/shared/components/DashboardTemplate/types';

export interface HiddenNestedRoutesProps {
  route: RouteType;
  hiddenNestedKeys?: string[];
  whitelistedSlugs?: string[];
}
const useHiddenNestedRoutes = ({
  route,
  hiddenNestedKeys = [],
  whitelistedSlugs = [],
}: HiddenNestedRoutesProps) => {
  const router = useRouter();
  const { slug } = router.query as { slug: string };
  let { nested } = route;

  if (
    nested &&
    hiddenNestedKeys?.length > 0 &&
    !whitelistedSlugs.includes(slug)
  ) {
    nested = nested.filter(route => !hiddenNestedKeys.includes(route.key));
  }

  return {
    routes: nested,
    error: !whitelistedSlugs.includes(slug),
  };
};

export default useHiddenNestedRoutes;
